import { render, staticRenderFns } from "./RoleCreate.vue?vue&type=template&id=ccfb9be8&scoped=true&"
import script from "./RoleCreate.vue?vue&type=script&lang=js&"
export * from "./RoleCreate.vue?vue&type=script&lang=js&"
import style0 from "./RoleCreate.vue?vue&type=style&index=0&id=ccfb9be8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfb9be8",
  null
  
)

export default component.exports